/**
 * Created by Ning Jiang on 11/22/2016.
 */

/**
 * Modified by Pradeep Kumar on 01/18/2019.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {CreepyCarnivalTwoGameModuleConfig} from "./CreepyCarnivalTwoGameModuleConfig";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {ICreepyCarnivalTwoGameData} from "./server/data/ICreepyCarnivalTwoServerData";
import {CreepyCarnivalTwoParsedGameData} from "./server/data/CreepyCarnivalTwoParsedGameData";
import {CreepyCarnivalTwoServerDataParser} from "./server/CreepyCarnivalTwoServerDataParser";

export class CreepyCarnivalTwo extends SlotGame {
    private isActionSpinsActive:boolean;
    private lastData:ICreepyCarnivalTwoGameData | undefined;

    constructor() {
        super(CreepyCarnivalTwoGameModuleConfig.instance);
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "L5",
                    "M1",
                    "L4"
                ],
                [
                    "L1",
                    "L4",
                    "M4"
                ],
                [
                    "L3",
                    "L5",
                    "M4"
                ],
                [
                    "L2",
                    "M2",
                    "L1"
                ],
                [
                    "L2",
                    "L1",
                    "L5"
                ]
            ],
            "evaluatedReels": [
                [
                    "L5",
                    "M1",
                    "L4"
                ],
                [
                    "L1",
                    "L4",
                    "M4"
                ],
                [
                    "L3",
                    "L5",
                    "M4"
                ],
                [
                    "L2",
                    "M2",
                    "L1"
                ],
                [
                    "L2",
                    "L1",
                    "L5"
                ]
            ],
            "betLineWins": [],
            "totalBetLineWins": 0,
            "totalSpinWinningsNotMultiplied": 0,
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "nearWinReels": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "freespinTriggeredThisSpin": false,
            "respinBaseTriggeredThisSpin": false,
            "respinFSTriggeredThisSpin": false,
            "freespinPlayed": 0,
            "freespinsLeft": 0,
            "numberOfScatters": 0,
            "scatterPositions": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "freespinRetriggered": false,
            "respinPlayed": 0,
            "respinPositionsBefore": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "respinPositionsAfter": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "payoutWinMultiplier": 1,
            "numberOfExtraFreespinsAwarded": 0,
            "starSpinSymbolsCollectedBefore": [
                {
                    "symbol": "M2",
                    "betValue": 1
                }
            ],
            "starSpinSymbolsCollectedAfter": [
                {
                    "symbol": "M2",
                    "betValue": 1
                }
            ],
            "winPositions": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "starSpinBetValue": 0
        };
    }



    start():Promise<NolimitPlugin> {

        CreepyCarnivalTwo.api.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE, (data:boolean)=>{
            if (this.isActionSpinsActive && !data){
                if (this.lastData?.starSpinSymbolsCollectedAfter){
                    CreepyCarnivalTwoGameModuleConfig.starMeter.updateStarCounter(this.lastData.starSpinSymbolsCollectedAfter.length);
                    CreepyCarnivalTwoGameModuleConfig.starStatusScreen.update(this.lastData.starSpinSymbolsCollectedAfter)
                }
            }
            this.isActionSpinsActive = data;
        });

        CreepyCarnivalTwo.api.events.on(APIEvent.GAME, (data:ICreepyCarnivalTwoGameData)=>{
            this.lastData = data;
        });


        return super.start();
    }
}